import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-cloneable', 'addRow', 'Lisa rida');
Labels.set('ui-table-cloneable', 'removeRow', 'Eemalda rida');
